import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { CreateClub } from "./club/CreateClub";
import { SignIn } from "./auth/SignIn";
import { Dashboard } from "./ui/Dashboard";
import { RouteGuard } from "./ui/RouteGuard";
import { setLocale } from "yup";
import { it } from "yup-locales";
import axios from "axios";
import { CreateUser } from "./users/CreateUser";
import { ThemeProvider, createTheme, responsiveFontSizes } from "@mui/material/styles";
import React from "react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { it as itLocale } from "date-fns/locale";
import { SnackbarProvider } from "notistack";
import { Users } from "./users/Users";
import { ForgotPassword } from "./auth/ForgotPassword";
import { ChangePassword } from "./auth/ChangePassword";
import { Clubs } from "./club/Clubs";
import { Risorsa } from "./club/Risorsa";
import { TipologieAssociazioni } from "./tipologieAssociazione/TipologieAssociazioni";
import { TipologieUso } from "./tipologieUso/TipologieUso";
import { TariffeDefinizioni } from "./tariffeDefinizioni/TariffeDefinizioni";
import { GestioneRisorse } from "./clubAdmin/GestioneRisorse";
import { Prenotazioni } from "./tabellone/Prenotazioni";
import CssBaseline from "@mui/material/CssBaseline";
import { Prenotazione } from "./prenotazione/Prenotazione";
import { VisualizzaPrenotazioni } from "./prenotazione/VisualizzaPrenotazioni";
import { GestionePrenotazioni } from "./prenotazione/GestionePrenotazioni";
import { Logout, Logout2 } from "./auth/Logout";
import { GestioneConti } from "./conti/GestioneConti";
import { Causali } from "./causali/Causali";
import { AddTran } from "./conti/AddTran";
import { BackOffice } from "./users/BackOffice";
import { LoginApi } from "./auth/LoginApi";
import { CambiaPassword } from "./auth/CambiaPassword";
import { Tipologie } from "./tipologie/Tipologie";
import { Specifica } from "./specifiche/Specifica";
import { Statistiche } from "./stats/Statistiche";
import { Domotica } from "./domotica/Domotica";
import { AccensioniProg } from "./domotica/AccensioniProg";
import { MessaggiAdmin } from "./messaggi/MessaggiAdmin";
import { ComunicazionePage } from "./messaggi/ComunicazionePage";
import { Ricarica } from "./ricarica/Ricarica";
import { MetodiPagamento } from "./ricarica/MetodiPagamento";
import { Satispay } from "./ricarica/Satispay";
import { SatispayReturn } from "./ricarica/SatispayReturn";
import { PagamentiSatispay } from "./ricarica/PagamentiSatispay";
import { ImpostazioniClub } from "./club/ImpostazioniClub";
import { ListaTransazioni } from "./conti/ListaTransazioni";

export const queryClient = new QueryClient();

export enum Roles {
  ADMIN,
  USER,
  CLUB_ADMIN,
}
setLocale(it);

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (401 === error.response.status) {
      console.warn("Autorizzazione scaduta!");
      localStorage.clear();
      if (!window.location.href.endsWith("login")) window.location.href = "/login";
      return error;
    } else {
      return Promise.reject(error);
    }
  },
);

export function App() {
  const theme = React.useMemo(
    () =>
      responsiveFontSizes(
        createTheme({
          typography: {
            h1: {
              fontSize: "3rem",
            },
            h2: {
              fontSize: "2.5rem",
            },
            h3: {
              fontSize: "2rem",
            },
            h4: {
              fontSize: "1.66rem",
            },
            h5: {
              fontSize: "1.33rem",
            },
            h6: {
              fontSize: "1rem",
            },
          },
        }),
      ),
    [],
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider maxSnack={3}>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={itLocale}>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <Routes>
                <Route path="/">
                  <Route path="login" element={<SignIn />}></Route>
                  <Route path="loginApi/:role/:token" element={<LoginApi />}></Route>
                  <Route path="logout" element={<Logout />}></Route>
                  <Route path="logout2" element={<Logout2 />}></Route>
                  <Route path="forgotPassword" element={<ForgotPassword />}></Route>
                  <Route path="changePassword/:id/:token" element={<ChangePassword />}></Route>

                  <Route
                    path="/app"
                    element={
                      <RouteGuard>
                        <Dashboard />
                      </RouteGuard>
                    }
                  >
                    <Route path="login" element={<SignIn />}></Route>
                    <Route path="tipologie" element={<Tipologie />}></Route>
                    <Route path="specifica" element={<Specifica />}></Route>
                    <Route path="cambiaPassword" element={<CambiaPassword />}></Route>
                    <Route path="createClub" element={<CreateClub />}></Route>
                    <Route path="clubs" element={<Clubs />}></Route>
                    <Route path="editClub/:id" element={<CreateClub />}></Route>
                    <Route path="createUser" element={<CreateUser />}></Route>
                    <Route path="editUser/:id" element={<CreateUser />}></Route>
                    <Route path="createRisorsa/:ClubId" element={<Risorsa />}></Route>
                    <Route path="editRisorsa/:id" element={<Risorsa />}></Route>
                    <Route path="users" element={<Users />}></Route>
                    <Route path="tipiAssociazioni" element={<TipologieAssociazioni />}></Route>
                    <Route path="tipologieUso" element={<TipologieUso />}></Route>
                    <Route path="tariffeDefinizioni" element={<TariffeDefinizioni />}></Route>
                    <Route path="gestioneRisorse" element={<GestioneRisorse />}></Route>
                    <Route path="tabelloneTariffe/:prenota" element={<Prenotazioni />}></Route>
                    <Route path="prenotazione" element={<Prenotazione />}></Route>
                    <Route
                      path="visualizzazionePresenze"
                      element={<VisualizzaPrenotazioni />}
                    ></Route>
                    <Route
                      path="gestionePrenotazioni"
                      element={<GestionePrenotazioni altri={false} />}
                    ></Route>
                    <Route
                      path="gestionePrenotazioniAltri"
                      element={<GestionePrenotazioni altri={true} />}
                    ></Route>
                    <Route path="conti" element={<GestioneConti />}></Route>
                    <Route path="causali" element={<Causali />}></Route>
                    <Route path="addTran" element={<AddTran />}></Route>

                    <Route path="backOffice" element={<BackOffice />}></Route>

                    <Route path="statistiche" element={<Statistiche />}></Route>
                    <Route path="listaTransazioni" element={<ListaTransazioni />}></Route>

                    <Route path="domotica" element={<Domotica />}></Route>
                    <Route path="accensioni" element={<AccensioniProg />}></Route>
                    <Route path="messaggiAdmin" element={<MessaggiAdmin />}></Route>
                    <Route path="comunicazioni/:id" element={<ComunicazionePage />}></Route>
                    <Route path="impostazioniClub" element={<ImpostazioniClub />}></Route>

                    <Route path="ricarica/metodiPagamento" element={<Ricarica />}></Route>
                    <Route path="ricarica/pagamentiSatispay" element={<PagamentiSatispay />}></Route>
                    <Route path="ricarica" element={<Ricarica />}></Route>
                    <Route path="ricarica/satispay" element={<Satispay />}></Route>
                    <Route path="ricarica/satispayreturn" element={<SatispayReturn />}></Route>
                  </Route>

                  <Route path="/public" element={<Dashboard />}>
                    <Route path="prenotazione" element={<Prenotazioni />}></Route>
                  </Route>

                  <Route path="/" element={<SignIn />}></Route>
                </Route>
              </Routes>
            </BrowserRouter>
          </QueryClientProvider>
        </LocalizationProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}
